import * as APPDATA from '@/constants/pcConstAppData';
import {RestAPI} from '@/constants/routeAPI';

import axiosMethods from './apiManager';

export const createAdvSetupApi = (advSetup) => {
  const param = {
    [APPDATA.KEY.Id]: advSetup.Id,
    [APPDATA.KEY.Name]: advSetup.Name,
    ...advSetup,
  };

  return axiosMethods.post(RestAPI.ADV_SETUP, param);
};

export const editAdvSetupApi = (advSetup) => {
  const param = {
    [APPDATA.KEY.Id]: advSetup.Id,
    [APPDATA.KEY.Name]: advSetup.Name,
    ...advSetup,
  };
  return axiosMethods.put(RestAPI.ADV_SETUP, param);
};

export const getDefaultAdvSetupApi = async () => {
  const response = await axiosMethods.get(RestAPI.DEFAULT_ADV_SETUP, null, true, true);
  return response;
};

export const getAdvSetupsApi = async () => {
  const response = await axiosMethods.get(RestAPI.ADV_SETUP, null, true, true);
  return response;
};

export const getSelectedAdvSetupsApi = async (id) => {
  const response = await axiosMethods.get(`${RestAPI.ADV_SETUP}/${id}`, null, true, true);
  return response;
};
